<template>
  <div class="max-h-[98vh]" :key="pageTitle">
    <PageTitleVue
      :sub-title="subTitle"
      :key="subTitle"
    >
      {{ pageTitle }}

      <!-- go back button -->
      <template #action>
        <div
          class="cursor-pointer text-gray-400"
          :key="backPage"
          v-if="
            dataExtinguisher.state.componentActive.__name !== 'SectorsCards' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorForm' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorFormUpdate'
          "
        >
          <p class="flex" @click="setBackComponent()">
            <component
              :is="PhArrowLeft"
              class="w-7 h-7 p-1"
            />
            <p class="my-auto">voltar</p>
          </p>
        </div>
      </template>

      <template #b-action>
        <div v-if="buttonActive">
          <Create
            :icon="PhFactory"
            :label="'Cadastrar'"
            :width-maximus="true"
            @click="setComponentActive(SectorForm)"
            v-if="dataExtinguisher.state.componentActive.__name == 'SectorsCards'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Ver tudo'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorForm'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Voltar as provas'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorFormUpdate'"
          />
        </div>
      </template>
    </PageTitleVue>

    <Transition mode="out-in">
      <div :key="componentActive" class="overflow-hidden">
        <keep-alive>
          <component :is="componentActive"/>
        </keep-alive>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import SectorsCards from './layout/pages/SectorsCards.vue'
import ExtinguisherService from './service/extinguisher.service'
import Create from '@/components/Buttons/Create.vue'
import SectorForm from './layout/SectorForm.vue'
import { PhArrowLeft, PhFactory } from '@phosphor-icons/vue'
import { onBeforeMount, computed, markRaw } from 'vue'
import { storeApp } from '@/store'
import { dataExtinguisher } from './store'
import { dataEvent } from '../events/store'

const componentActive = computed(() => markRaw(dataExtinguisher.getters.getActiveComponent))
const buttonActive = computed(() => dataExtinguisher.getters.getIfButtonActive)
const subTitle = computed(() => dataExtinguisher.getters.getPageSubTitle)
const backPage = computed(() => dataExtinguisher.getters.backToComponent)

const pageTitle = computed(() => {
  if (dataExtinguisher.state.componentActive.__name == 'SectorsCards') {
    dataExtinguisher.dispatch('setPageTitle', 'AVALIAÇÕES')
    dataExtinguisher.dispatch('setPageSubTitle', 'Gerencie todas as avaliações')
  }

  if (dataExtinguisher.state.componentActive.__name == 'SectorForm') {
    dataExtinguisher.dispatch('setPageTitle', 'NOVA AVALIAÇÃO')
    dataExtinguisher.dispatch('setPageSubTitle', 'Cadastre uma nova avaliação')
  }

  if (dataExtinguisher.state.componentActive.__name == 'SectorFormUpdate') {
    dataExtinguisher.dispatch('setPageTitle', 'ALTERAR AVALIAÇÃO')
    dataExtinguisher.dispatch('setPageSubTitle', 'Altere os dados desta avaliação')
  }

  return dataExtinguisher.getters.getTitle
})

function setComponentActive (value) {
  dataExtinguisher.dispatch('resetForm')
  dataExtinguisher.dispatch('setComponentActive', markRaw(value))
}

// todas as provas
async function getAssessment () {
  await ExtinguisherService.listAssessment()
    .then((res) => {
      dataExtinguisher.dispatch('setAllAssessments', res.data)
    })
    .catch((err) => {
      console.log(err)
    })
}

onBeforeMount(async () => {
  storeApp.state.loading = true
  dataExtinguisher.dispatch('setComponentActive', markRaw(SectorsCards))
  dataExtinguisher.dispatch('setBackComponent', 'SectorsCards')

  await getAssessment()

  Promise.all([
    dataExtinguisher.dispatch('getComboTraining')
  ])

  storeApp.state.loading = false
})

</script>

<style lang="scss">
::v-deep .v-enter-from,
::v-deep .v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

::v-deep .v-enter-active,
::v-deep .v-leave-active {
  transition: all 0.3s;
}
</style>
